import isNil from "lodash/isNil";

export const formatDate = (date, time = true) => {
  if (isNaN(Date.parse(date))) {
    return date;
  }

  const dateObject = new Date(date);

  try {
    let result = dateObject.toLocaleDateString("en-GB");
    if (time) {
      result += " " + dateObject.toLocaleTimeString();
    }

    return result;
  } catch (e) {
    return date;
  }
};

export const downloadFile = (data, fileName = "data.csv", type = "text/csv") => {
  const newBlob = new Blob([data], { type: type });
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const url = window.URL.createObjectURL(newBlob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName); //or any other extension
  document.body.appendChild(link);
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(url);
  }, 100);
};

export const formatCurrency = (value) =>
  +value ? Number(value).toLocaleString(undefined, { maximumFractionDigits: 10 }) : value;

export const blank = (value) => isNil(value) || value === "";
export const filled = (value) => !blank(value);
